export default {
  REQUEST_FETCH_COMMUNITYS: 'REQUEST_FETCH_COMMUNITYS',
  FETCH_COMMUNITYS_ERROR: 'FETCH_COMMUNITYS_ERROR',
  FETCH_COMMUNITYS_SUCCESS: 'FETCH_COMMUNITYS_SUCCESS',
  RESET_COMMUNITY: 'RESET_COMMUNITY'
}
